module.exports = __webpack_public_path__ + "static/img/image1.792ef3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image1.png
// module id = tJ3u
// module chunks = 0